import React from 'react';
import PropTypes from 'prop-types';

const renderTextarea = ({ input, placeholder, meta: { touched, error } }) => (
  <div className="form__form-group-input-wrap">
    <textarea {...input} placeholder={placeholder} />
    {touched && error && <span className="form__form-group-error">{error}</span>}
  </div>
);

renderTextarea.propTypes = {
  input: PropTypes.shape().isRequired,
  placeholder: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
};

renderTextarea.defaultProps = {
  placeholder: '',
  meta: null,
};

export default renderTextarea;
